import { DatePipe } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { reducer } from '../core/store/profile/profile.reducer';
import { SettingsStateKeys } from '@libs/entity-lib';
import { EffectsModule } from '@ngrx/effects';
import { coreEffectsAtBootstrap } from '../core/store/core.effects';
import { CoreModule } from '../core/core.module';
import { CrudLessorLibService } from '../core/services/crud-lessor/crud-lessor-lib.service';
import { quickRegisterReducer } from '../core/store/quick-register/quick-register.reducer';

@NgModule({
  declarations: [],
  imports: [
    StoreModule.forFeature(SettingsStateKeys.CRUD_PROFILE_SOCIAL_SPORT, reducer),
    StoreModule.forFeature(SettingsStateKeys.QUICK_USER, quickRegisterReducer),
    EffectsModule.forFeature(coreEffectsAtBootstrap),
    CoreModule,
  ],
  providers: [DatePipe, CrudLessorLibService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CrudProfileLibModule {}
